export class Invitation {
  constructor(
    public username: string,
    public email: string,
    public additionalUsernames: string[]
  ) {}

  userAlreadyExists = false;
  emailExists = false;
}
